import { axiosServerData, NetsuiteInstanceProps } from 'src/utils/axios';
// types
import { ICustomerFormValues } from 'src/types/customer'

const param = { firstEndPoint: 'customer', lastEndPoint: "root" } as NetsuiteInstanceProps;

const initParam = ({ idUser, data, endUrl, headers= {}, firstEndPoint, lastEndPoint, method, endpointParam }: NetsuiteInstanceProps) => {
  param.data = data;
  param.endUrl = endUrl || '';
  param.idUser = idUser;
  param.firstEndPoint = firstEndPoint ?? 'customer'
  param.lastEndPoint = lastEndPoint ?? 'root'
  // @ts-ignore
  param.endpointParam = endpointParam;
  param.method = method;
  param.headers = headers;
};

export const getCustomers = (
  idUser: string,
  config: string,
  search?: string,
  page: number = 1,
  limit: number = 500
) => {
  const queryParams = new URLSearchParams();

  if (search) {
    const searchParams = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    searchParams.forEach((value, key) => {
      queryParams.append(key, value);
    });
  }

  queryParams.set('page', page.toString());
  queryParams.set('limit', limit.toString());

  initParam({
    idUser,
    method: 'get',
    endUrl: `?${queryParams.toString()}`,
    headers: { config }
  } as unknown as NetsuiteInstanceProps);
  return axiosServerData(param);
};

export const createCustomer = async (idUser: string, config: string, data: ICustomerFormValues) => {
  // Format the data to match the expected API format
  const formattedData = {
    ...data,
    // Ensure phone is set (fallback to phoneNumber for backward compatibility)
    phone: data.phone || data.phoneNumber || '',
    // Flatten address if needed
    ...(data.address && {
      street: data.address.street || '',
      city: data.address.city || '',
      state: data.address.state || '',
      country: data.address.country || '',
      zipCode: data.address.zipCode || '',
    })
  };

  initParam({
    idUser,
    data: formattedData,
    method: 'post',
    headers: { config }
  } as unknown as NetsuiteInstanceProps);

  return axiosServerData(param);
};

export const getCustomerDetails = async (idUser: string, config: string, customerId: string) => {
  initParam({
    idUser,
    method: 'get',
    endUrl: `/${customerId}`,
    headers: { config }
  } as unknown as NetsuiteInstanceProps);
  return axiosServerData(param);
};

export const toggleVoucherStatus = async (idUser: string, config: string, voucherId: string, status: 'active' | 'inactive' | 'cancelled') => {
  initParam({
    idUser,
    method: 'post',
    endUrl: `/voucher/${voucherId}/toggle`,
    data: { status },
    headers: { config }
  } as unknown as NetsuiteInstanceProps);
  return axiosServerData(param);
};

export const updateCustomer = async (idUser: string, config: string, customerId: string, data: ICustomerFormValues) => {
  // Format the data to match the expected API format
  const formattedData = {
    ...data,
    // Ensure phone is set (fallback to phoneNumber for backward compatibility)
    phone: data.phone || data.phoneNumber || '',
    // Flatten address if needed
    ...(data.address && {
      street: data.address.street || '',
      city: data.address.city || '',
      state: data.address.state || '',
      country: data.address.country || '',
      zipCode: data.address.zipCode || '',
    })
  };

  initParam({
    idUser,
    data: formattedData,
    method: 'patch',
    firstEndPoint: 'customer',
    lastEndPoint: 'root',
    endUrl: `/${customerId}`,
    headers: { config }
  } as unknown as NetsuiteInstanceProps);

  return axiosServerData(param);
};
